export default __webpack_public_path__ + "static/media/Logo-IM-bad.98a4d8fa.png";